import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { _setAxios } from '../../lib/Helper';

async function fetchList() {
  return await _setAxios("mata-pelajaran")
    .then(body => {
      let results = []
      body.data?.data?.forEach(row => {
        results.push({
          label: row.nama,
          value: parseInt(row.id),
        })
      });

      return results
    })
}

const SelectMataPelajaran = ({ setOptions: setParentOptions, ...props }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetchList().then((newOptions) => {
      setOptions(newOptions);
      if (setParentOptions) {
        setParentOptions(newOptions);
      }
    });
  }, [setParentOptions]);

  return (
    <Select
      {...props}
      allowClear
      placeholder="Pilih mata pelajaran"
      style={{
        width: '100%',
      }}
      options={options}
      filterOption={(input, option) =>
        option?.label?.toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};
export default SelectMataPelajaran;
